import React, { useState, useEffect } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import { FaCog, FaArrowLeft } from "react-icons/fa";
import config from "../../../config/config";
import axios from "axios";

const Profile = () => {
  const { clientUser } = useOutletContext();
  const [isLeftActive, setIsLeftActive] = useState(false);
  const [isRightActive, setIsRightActive] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isPersonalDetailsUpdated, setPersonalDetailsUpdated] = useState(false);
  const [isPaymentDetailsUpdated, setPaymentDetailsUpdated] = useState(false);
  const [isContactDetailsUpdated, setContactDetailsUpdated] = useState(false);
  const baseURL = config.API_BASE_URL;

   useEffect(() => {
console.log("Profile: clientUser =", clientUser);
 }, [clientUser]);

  useEffect(() => {
    const handleResize = () => {
      const small = window.innerWidth <= 768;
      console.log("Current window width:", window.innerWidth, "isSmallScreen:", small);
      setIsSmallScreen(small);
      if (!small) {
        setIsLeftActive(true);
        setIsRightActive(true);
      } else {
        setIsLeftActive(true);
        setIsRightActive(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize(); 

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (clientUser && clientUser.id) {
        try {
          const response = await axios.get(
            `${baseURL}/v1/client-users/${clientUser.id}`
          );
          const userData = response.data;

          if (userData) {
            console.log(
              "Data fetched on component mount or user/baseURL change",
              userData
            );
            setPersonalDetailsUpdated(userData.personalDetailsUpdated);
            setPaymentDetailsUpdated(userData.paymentDetailsUpdated);
            setContactDetailsUpdated(userData.contactDetailsUpdated);
          }
        } catch (error) {
          console.error("Failed to fetch User Data:", error);
        }
      }
    };

    fetchData();

    const handleVisibilityChange = async () => {
      if (document.visibilityState === "visible") {
        console.log("Tab is now visible, fetching data...");
        await fetchData();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [clientUser, baseURL]);

  const activeLinkStyle = ({ isActive }) =>
    isActive
      ? {
        backgroundColor: "#f5f5f5",
        color: "#145966",
        padding: "5px 15px 6px 10px",
        fontWeight: "500",
      }
      : undefined;


  const handleNavClick = () => {
    console.log("Nav item clicked", isSmallScreen);
    if (isSmallScreen) {
      setIsLeftActive(false);
      setIsRightActive(true);
    }
  };

  const handleBackClick = () => {
    if (isSmallScreen) {
      setIsLeftActive(true);
      setIsRightActive(false);
    }
  };

  return (
    <div className="profile-container">
      {isLeftActive && (
        <div className="profile-left-container">
          <div className="profile-left-div">
            <h4>Account Details</h4>
            <div className="profile-link-container">
              <input
                type="checkbox"
                className="rounded-checkbox"
                checked={isPersonalDetailsUpdated}
                readOnly
              />
              <NavLink
                to="/account/fs-dashboard/my-account/personal-details"
                className="profile-link"
                style={activeLinkStyle}
                onClick={handleNavClick}
              >
                Personal details
              </NavLink>
            </div>
            <div className="profile-link-container">
              <input
                type="checkbox"
                className="rounded-checkbox"
                checked={isPaymentDetailsUpdated}
                readOnly
              />
              <NavLink
                to="/account/fs-dashboard/my-account/payment-details"
                className="profile-link"
                style={activeLinkStyle}
                onClick={handleNavClick}
              >
                Payment details
              </NavLink>
            </div>
            <div className="profile-link-container">
              <input
                type="checkbox"
                className="rounded-checkbox"
                checked={isContactDetailsUpdated}
                readOnly
              />
              <NavLink
                to="/account/fs-dashboard/my-account/emergency-contacts"
                className="profile-link"
                style={activeLinkStyle}
                onClick={handleNavClick}
              >
                Emergency contacts
              </NavLink>
            </div>
            <div className="profile-link-container">
              <FaCog className="accnt-settings-icon" />
              <NavLink
                to="account-settings"
                className="profile-link"
                style={activeLinkStyle}
                onClick={handleNavClick}
              >
                Account Settings
              </NavLink>
            </div>
          </div>
        </div>
      )}
      {isRightActive && (
        <div className="profile-right-container">
          {isSmallScreen && (
            <div className="profile-back-arrow" onClick={handleBackClick}>
              <FaArrowLeft className="profile-back-icon" /> Back
            </div>
          )}
          <Outlet />
        </div>
      )}
    </div>
  );
};

export default Profile;
